module.exports = __webpack_public_path__ + "img/step2-2.2c9dc9d2.png";